import React from 'react';
import { Calendar, Plus, AlertTriangle } from 'lucide-react';
import ExamenSession from './ExamenSession';

const ExamenSessionsList = ({ 
  sessions, 
  modules, 
  salles, 
  surveillants, // Remplace utilisateurs
  onSessionChange, 
  onCreneauChange, 
  onAddSession, 
  onAddCreneau, 
  onRemoveCreneau, 
  onRemoveSession 
}) => {

  const getTotalSessions = () => sessions.length;
  const getTotalCreneaux = () => sessions.reduce((total, session) => total + session.creneaux.length, 0);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      {/* Header avec statistiques */}
      <div className="bg-gradient-to-r from-[#202654] to-[#202654]/90 px-6 py-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center text-white">
            <div className="bg-white/10 p-2 rounded-lg mr-3">
              <Calendar className="h-6 w-6" />
            </div>
            <div>
              <h2 className="text-lg font-semibold">Sessions d'examen</h2>
              <p className="text-blue-100 text-sm">
                Organisez vos sessions et créneaux d'examen
              </p>
            </div>
          </div>
          
          {/* Statistiques */}
          <div className="flex items-center space-x-4 mt-3 sm:mt-0">
            <div className="flex items-center space-x-3">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-white/20 text-white">
                📅 {getTotalSessions()} session{getTotalSessions() > 1 ? 's' : ''}
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-white/20 text-white">
                ⏰ {getTotalCreneaux()} créneau{getTotalCreneaux() > 1 ? 'x' : ''}
              </span>
            </div>
            
            <button
              type="button"
              onClick={onAddSession}
              className="inline-flex items-center px-4 py-2 bg-white/20 hover:bg-white/30 text-white rounded-lg font-medium transition-colors"
            >
              <Plus className="h-4 w-4 mr-2" />
              Ajouter une session
            </button>
          </div>
        </div>
      </div>

      {/* Contenu des sessions */}
      <div className="p-6">
        {sessions.length === 0 ? (
          // État vide
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Calendar className="h-8 w-8 text-gray-400" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Aucune session d'examen
            </h3>
            <p className="text-gray-500 mb-6">
              Commencez par ajouter une session d'examen pour organiser vos épreuves.
            </p>
            <button
              type="button"
              onClick={onAddSession}
              className="inline-flex items-center px-4 py-2 bg-[#202654] text-white rounded-lg hover:bg-[#1a1f4a] transition-colors"
            >
              <Plus className="h-4 w-4 mr-2" />
              Créer ma première session
            </button>
          </div>
        ) : (
          // Liste des sessions
          <div className="space-y-6">
            {sessions.map((session, sessionIndex) => (
              <ExamenSession
                key={sessionIndex}
                session={session}
                sessionIndex={sessionIndex}
                modules={modules}
                salles={salles}
                surveillants={surveillants}
                onSessionChange={onSessionChange}
                onCreneauChange={onCreneauChange}
                onAddCreneau={onAddCreneau}
                onRemoveCreneau={onRemoveCreneau}
                onRemoveSession={onRemoveSession}
                canRemoveSession={sessions.length > 1}
              />
            ))}

            {/* Bouton d'ajout en bas */}
            <div className="flex justify-center pt-4">
              <button
                type="button"
                onClick={onAddSession}
                className="inline-flex items-center px-6 py-3 border-2 border-dashed border-gray-300 text-gray-600 rounded-lg hover:border-[#202654] hover:text-[#202654] transition-colors"
              >
                <Plus className="h-5 w-5 mr-2" />
                Ajouter une nouvelle session
              </button>
            </div>
          </div>
        )}

        {/* Messages d'aide */}
        {sessions.length > 0 && (
          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <AlertTriangle className="h-5 w-5 text-blue-600" />
              </div>
              <div className="ml-3">
                <h4 className="text-sm font-medium text-blue-800">
                  Conseils pour l'organisation
                </h4>
                <div className="mt-2 text-sm text-blue-700">
                  <ul className="list-disc list-inside space-y-1">
                    <li>Assurez-vous que les horaires ne se chevauchent pas pour une même salle</li>
                    <li>Vérifiez la disponibilité des surveillants avant affectation</li>
                    <li>La capacité des salles doit être suffisante pour le nombre d'étudiants</li>
                    <li>Prévoyez des créneaux de surveillance avec surveillants principal et secondaire</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExamenSessionsList; 